import { internalClient } from "./internalClient";

type TCreateBookingParams = {
    shop: string;
    datestart: string;
    dateend: string;
    phonenumber: string;
    comment: string;
};

export async function createBooking(params: TCreateBookingParams) {
    const response = await internalClient.post('', {
        action: 'createBooking',
        ...params,
    })

    return response.data;
}